import { useQuery } from 'react-query';
import { apiResourceLinks } from '../constants/apiResourceLinks';
import { dotNetAxios, AxiosQueryResponse } from '../utils/axios';
import { Account } from '../types/request';
import debounce from 'debounce-promise';
import { toOption } from '../utils/select';

export const debounceGetAccounts = debounce((params?: AccountsQueryParams) => getAccounts(params).then((data) => data?.map((item) => toOption(item.id))), 1000);

export interface AccountsQueryParams {
  searchString?: string;
  onlyChildAccounts?: boolean;
}
export const getAccounts = async (params?: AccountsQueryParams): Promise<Account[] | undefined> => {
  const { data }: AxiosQueryResponse = await dotNetAxios.get(apiResourceLinks.getAccounts, {
    params
  });

  return data;
};

export const useAccountsQuery = () => {
  return useQuery<Account[] | undefined>(['accounts'], () => getAccounts(), {
    onSuccess: (data) => {
      return data;
    },
    onError: () => {}
  });
};
